export default {
    'results': [
        {
            key: 'check',
            components: [
                { "type": "title", "size": 'xs12' },
                { "type": "checkinfo", "size": 'xs12' },
                { "type": "chart", "size": 'xs12', "note": "Mouse over graph for more detail.  The graph will display the timeout as the result for checks that timed out." },
                { "type": "table", "size": 'xs12' }
            ]
        }
    ],
    'statusevents': [
        {
            key: 'check',
            components: [

            ]
        }
    ]
};
